// extracted by mini-css-extract-plugin
export var section = "styles-module--section--8ff4b";
export var tagline = "styles-module--tagline--0d8ea";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--a7d0c";
export var wordContainer = "styles-module--wordContainer--389ec";